import { render } from "./Contact.vue?vue&type=template&id=6d429bfd&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=6d429bfd&lang=scss&scoped=true"

import exportComponent from "/var/www/digital-card-solution-limited/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d429bfd"]])

export default __exports__